import React, { Component } from 'react'
import {Form, Button} from 'react-bootstrap'
import './css/newUser.scss'
import {addUser} from '../functions/firebase'

const avatars = ['1','2','3','4','5','6','7','8','9','10','11','12']

export default class NewUser extends Component {
    state={
        avatar:`${window.location.origin}/avatars/1.png`
    }
    onChange = event =>{
        this.setState({
            [event.target.name]:event.target.value
        })
        console.log(this.state);
        
    }
    pick = img =>{ 
        this.setState({
            avatar:`${window.location.origin}/avatars/${img}.png`
        })
    }
    onSubmit = () => {
        addUser({ 
            id: this.props.userid,
            name : this.state.name,
            avatar : this.state.avatar
        })
    }
    render() {
        return (
            <div className="containThis" style={{marginTop:'20vh'}}>
  <Form.Group controlId="formBasicEmail">
    <Form.Label>Name</Form.Label>
    <Form.Control onChange={this.onChange} name='name'type="text" placeholder="display Name " />
    <Form.Text className="text-muted">
     Please enter your display name here
    </Form.Text>
  </Form.Group>   
  <div className="allAvatars">
      
            {avatars.map(imag => 
            
            <img src={`${window.location.origin}/avatars/${imag}.png`} className={this.state.avatar == `${window.location.origin}/avatars/${imag}.png`? 'clicked': ''} onClick={()=>this.pick(imag)} alt=""/> )}
</div> 
       <Button variant="primary" onClick={this.onSubmit} type="submit">
    Submit
  </Button>
     </div>
        )
    }
}
